/**
 * TEBOX typography for `apps/booking` — mirrors `docs/design-system/TEBOX_DESIGN_SYSTEM.html`
 * and `@boubou/tebox-design-system` (seven core tokens + contextual helpers).
 * Use `fontFamily: 'var(--brand-font)'` so club brand fonts apply.
 */
import type { CSSProperties } from 'react';
import { teboxDesignSystem } from '@boubou/tebox-design-system';

const t = teboxDesignSystem.typography;
const brandFace = { fontFamily: 'var(--brand-font)' as const };

/** Inline `fontFamily` for booking surfaces — matches `getFontFamilyCSS` on `:root`, not raw API `fontFamily` (multi-word names need quotes). */
export const bookingBrandFontFamilyVar = brandFace.fontFamily;

function pick(
  token: Record<string, string | number | undefined>,
  overrides?: CSSProperties,
): CSSProperties {
  return { ...token, ...brandFace, ...overrides } as CSSProperties;
}

/** Spread into inline styles; always includes `--brand-font`. */
export const teboxType = {
  h1: (o?: CSSProperties) => pick(t.h1, o),
  h2: (o?: CSSProperties) => pick(t.h2, o),
  h3: (o?: CSSProperties) => pick(t.h3, o),
  h4: (o?: CSSProperties) => pick(t.h4, o),
  formCardSectionTitle: (o?: CSSProperties) => pick(t.formCardSectionTitle, o),
  body: (o?: CSSProperties) => pick(t.body, o),
  bodySmall: (o?: CSSProperties) => pick(t.bodySmall, o),
  caption: (o?: CSSProperties) => pick(t.caption, o),
  fieldLabelBlock: (o?: CSSProperties) => pick(t.fieldLabelBlock, o),
  formSectionLabel: (o?: CSSProperties) => pick(t.formSectionLabel, o),
  pageHeaderSubtext: (o?: CSSProperties) => pick(t.pageHeaderSubtext, o),
} as const;

/** Raw token objects (no fontFamily override) for merging with existing style objects. */
export const teboxTypographyRaw = t;
